import React from 'react';
import Svg, {Path} from 'react-native-svg';

interface Props {
  width?: number;
  height?: number;
  color?: string;
}

/** Up-chevron — used to collapse / minimize the Nova AI chat window */
const NovaAIMinimizeCollapseIcon: React.FC<Props> = ({
  width = 36,
  height = 36,
  color = '#1C1C1C',
}) => (
  <Svg width={width} height={height} viewBox="0 0 36 36" fill="none">
    <Path
      d="M11 22L18 15L25 22"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);

export default NovaAIMinimizeCollapseIcon;